module.exports = __webpack_public_path__ + "static/media/097-recycle bin.8047ab5c.svg";